import styled from "styled-components";

export default function CustomerHero({ customer, onLogout }) {
  const displayName =
    [customer?.firstname, customer?.lastname].filter(Boolean).join(" ") ||
    customer?.username ||
    "Client Queen's Games";

  return (
    <HeroCard>
      <AvatarBlock>
        <AvatarInitial>{displayName.slice(0, 1).toUpperCase()}</AvatarInitial>
      </AvatarBlock>

      <HeroInfo>
        <PanelBadge>Espace client</PanelBadge>
        <h1>{displayName}</h1>
        <p>{customer?.email || "E-mail non renseigné"}</p>

        <MetaLine>
          <span>Queen's Games</span>
          <span>{customer?.city || "Ville non renseignée"}</span>
        </MetaLine>
      </HeroInfo>

      <HeroActions>
        <PrimaryButton type="button" onClick={onLogout}>
          Se déconnecter
        </PrimaryButton>
      </HeroActions>
    </HeroCard>
  );
}

const HeroCard = styled.article`
  display: flex;
  gap: 1.4rem;
  align-items: center;
  padding: 1.4rem;
  border-radius: 26px;
  background: #1d263d;
  margin-bottom: 1rem;

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const AvatarBlock = styled.div`
  display: grid;
  gap: 0.75rem;
  justify-items: center;
`;

const AvatarInitial = styled.div`
  width: 132px;
  height: 132px;
  border-radius: 999px;
  border: 4px solid #fff9ea;
  display: grid;
  place-items: center;
  background: #202a43;
  color: #fff9ea;
  font-size: 3rem;
  font-weight: 950;
`;

const HeroInfo = styled.div`
  flex: 1;

  h1 {
    margin: 0.8rem 0 0.4rem;
    font-size: clamp(1.6rem, 4vw, 2.35rem);
    font-weight: 950;
  }

  p {
    margin: 0;
    opacity: 0.78;
  }
`;

const HeroActions = styled.div`
  min-width: 180px;

  @media (max-width: 700px) {
    width: 100%;
  }
`;

const PanelBadge = styled.div`
  display: inline-block;
  padding: 0.35rem 0.7rem;
  border-radius: 999px;
  background: #fff9ea;
  color: #0b1328;
  font-size: 0.75rem;
  font-weight: 950;
`;

const MetaLine = styled.div`
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
  margin-top: 0.9rem;

  span {
    padding: 0.35rem 0.7rem;
    border-radius: 999px;
    background: rgba(255, 249, 234, 0.1);
    color: #fff9ea;
    font-size: 0.82rem;
    font-weight: 850;
  }
`;

const PrimaryButton = styled.button`
  width: 100%;
  border: none;
  border-radius: 12px;
  padding: 0.9rem 1rem;
  background: #fff9ea;
  color: #0b1328;
  font-weight: 950;
  cursor: pointer;
`;
